<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <FundHistoryOne :data-set="dataSet" @on-click-tab="onClickTab" @get-next-page-list="getNextPageList" />
    </div>
    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <FundHistoryTwo :data-set="dataSet" @on-click-tab="onClickTab" @get-next-page-list="getNextPageList" />
    </div>
    <!-- Theme three -->
    <div v-if="themeStore.themeIndex === 3">
        <FundHistoryThree :data-set="dataSet" @on-click-tab="onClickTab" @get-next-page-list="getNextPageList"
            :is-tab-view="isTabView" />
    </div>
    <!-- Theme four -->
    <div v-if="themeStore.themeIndex === 4">
        <FundHistoryFour :data-set="dataSet" @on-click-tab="onClickTab" @get-next-page-list="getNextPageList"
            :is-tab-view="isTabView" />
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';
import FundHistoryOne from '@/themes/themeOne/fundsHistory/fundHistory.vue';
import FundHistoryTwo from '@/themes/themeTwo/fundsHistory/fundHistory.vue';
import FundHistoryThree from '@/themes/themeThree/fundsHistory/fundHistory.vue';
import FundHistoryFour from '@/themes/themeFour/fundsHistory/fundHistory.vue';
import { CardDataItem, FundHistoryData, FUNDS_TABS, PAGE_SIZE } from './supportScript';
import { getUserFundHistory } from '@/api/fundsHistory';

const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref();
const toastContent = ref('');
const loadingRef = ref();

const active = ref(2);
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const tabList = ref(FUNDS_TABS)
const total = ref(0)
const dataLog = ref<CardDataItem[]>([])
const props = defineProps<{
    isTabView?: boolean
}>()
const dataSet = computed<FundHistoryData>(() => ({
    active: active.value,
    total: total.value,
    pageSize: pageSize.value,
    pageNum: pageNum.value,
    tabList: tabList.value,
    dataLog: dataLog.value
}))


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const onClickTab = (data: any) => {
    active.value = data.name
    total.value = 0
    pageNum.value = 1
    dataLog.value = []
    getUserFundHistoryData()
}
const getUserFundHistoryData = () => {
    loadingRef.value.open()
    let data = {
        pageSize: pageSize.value,
        pageNum: pageNum.value,
        logType: active.value
    }
    getUserFundHistory(data).then(res => {
        loadingRef.value.close()
        const resData = res.data
        total.value = resData.total || 0
        dataLog.value = [...dataLog.value, ...resData.records]
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close()
            showError(err);
        }
    })
}

const getNextPageList = () => {
    loadingRef.value.open()
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getUserFundHistoryData()
    }
}

onMounted(() => {
    getUserFundHistoryData()
})

</script>